import * as types from '../constants/ActionTypes.js';
let initLauguage = 'chinese';
try {
	if(window.localStorage.getItem('language')!==null){
		initLauguage = window.localStorage.getItem('language');
	}
}catch(e){

}
const initialState = {
  accessToken: null,
  islogin: false,
	user: null,
	language:initLauguage,
};

export default function CommonReducer(state = initialState, action){
	switch (action.type) {
		case types.IS_LOGIN:
	      return Object.assign({}, state, {
	        islogin: action.islogin,
	      });

	  case types.USER_INFO:
	    return Object.assign({}, state, {
	      user: action.user,
		});
		case types.Language:
		  console.log(action.language)
			return Object.assign({}, state, {
				language: action.language,
			});
	  default:
    	return state;
	}
}


// WEBPACK FOOTER //
// ./public/reducers/CommonReducer.js